import _taggedTemplateLiteral from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    position: absolute;\n    left: 25px;\n\n    [data-placement^='bottom'] &,\n    [data-placement^='top'] & {\n        margin-left: -8px;\n        position: absolute;\n    }\n\n    [data-placement^='bottom'] &,\n    [data-placement^='top'] &,\n    [data-placement^='bottom'] &::before,\n    [data-placement^='top'] &::before {\n        box-sizing: content-box;\n        position: absolute;\n        border: 8px solid transparent;\n        height: 0;\n        width: 1px;\n    }\n\n    [data-placement^='bottom'] &::before,\n    [data-placement^='top'] &::before {\n        content: '';\n        z-index: -1;\n        border-width: 8px;\n        left: -8px;\n        border-bottom-color: hsl(0, 0%, 100%);\n    }\n\n    [data-placement^='bottom'] & {\n        top: 0;\n        margin-top: -8px;\n    }\n\n    [data-placement^='bottom'] &,\n    [data-placement^='bottom'] &::before {\n        border-top: none;\n        border-bottom-color: hsl(0, 0%, 100%);\n    }\n\n    [data-placement^='bottom'] &::before {\n        top: -1px;\n        border-bottom-color: hsl(0, 0%, 100%);\n    }\n\n    [data-placement^='top'] & {\n        bottom: 0;\n        margin-bottom: -8px;\n    }\n\n    [data-placement^='top'] &,\n    [data-placement^='top'] &::before {\n        border-bottom: none;\n        border-top-color: hsl(0, 0%, 100%);\n    }\n\n    [data-placement^='top'] &::before {\n        bottom: -1px;\n        border-top-color: hsl(0, 0%, 100%);\n    }\n\n    [data-placement='bottom-end'] &,\n    [data-placement='top-end'] & {\n        left: auto;\n        right: 25px;\n    }\n\n    [data-placement^='right'] & {\n        left: auto;\n        right: 25px;\n    }\n    [data-placement^='left'] & {\n        left: 25px;\n        right: auto;\n    }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    box-sizing: border-box;\n    padding: 20px;\n    width: 320px;\n\n    ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import styled from 'styled-components';
import { Paper } from '../Paper';
import { typography } from '../mixins';
var StyledDatepickerContainer = styled(Paper)(_templateObject(), typography('body1'));
var BalloonArrow = styled.div(_templateObject2());
export var DatepickerContainer = function DatepickerContainer(_a) {
  var children = _a.children,
      props = __rest(_a, ["children"]);

  return React.createElement(StyledDatepickerContainer, Object.assign({}, props), React.createElement(BalloonArrow, null), children);
};